import { makeStyles } from '@mui/styles';

export const styles = makeStyles({
  btnAlign: {
    display: 'flex',
    flexDirection: 'row-reverse',
    position: 'absolute',
    zIndex: 1,
    right: 0,
  },
});
